import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router';
import { withIntl } from 'ha/i18n';

import {
  getCityName,
  getCollectionFilter,
  isSearchByPartner,
  getIsAdvertiserSearch,
  getAdvertiserName,
} from 'ha/pages/Search/selectors';
import SearchPageBreadcrumbs from '../components/SearchPageBreadcrumbs';

const enhance = compose(
  connect(
    createStructuredSelector({
      city: getCityName,
      canonicalCollection: getCollectionFilter,
      isSearchByPartner,
      isAdvertiserSearch: getIsAdvertiserSearch,
      advertiserName: getAdvertiserName,
    }),
  ),
  withIntl,
  withRouter,
);

export default enhance(SearchPageBreadcrumbs);
